module.exports = __webpack_public_path__ + "static/media/content-thuong-mai-1.b307f82b.jpg";